<template>
  <el-dialog
    title="Send Report to Email"
    lock-scroll
    width="30%"
    :visible.sync="popupOpen"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :append-to-body="true"
    @close="$emit('closePopup', true)"
  >
    <el-form
      ref="form"
      id="report-schedule"
      class="flex flex-col w-full h-full bg-primary-300 space-y-2 shadow-xl p-4 pt-0"
      v-loading="loading"
      :model="form"
      :rules="formRules"
      :disabled="loading"
    >
      <el-form-item
        prop="sendToMe"
        class="border-primary-100 border-radius rounded bg-primary-50 px-2 py-2"
      >
        <el-switch
          v-model="form.sendToMe"
          class="w-full"
          active-text="Send it to me"
        />
      </el-form-item>
      <el-form-item prop="Email">
        <div class="flex flex-col">
          <h5 class="text-base font-bold text-white">Email</h5>
          <p class="text-xs text-red-400">
            Must to valid internal e-mail address, no external addresses
            permitted
          </p>
        </div>
        <el-select
          class="w-full"
          v-model="form.Email"
          multiple
          filterable
          allow-create
          default-first-option
          placeholder="Type email here"
          :disabled="form.sendToMe"
        >
          <el-option
            v-for="item in EmailList"
            :key="item"
            :label="item"
            :value="item"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="Fullname">
        <h5 class="text-base font-bold text-white">Recipient's Name</h5>
        <el-input
          v-model="form.Fullname"
          placeholder="Recipient's Name"
          clearable
          :disabled="form.sendToMe"
          @blur="setFormattedMessage"
        />
      </el-form-item>
      <el-form-item prop="ReportTitle">
        <h5 class="text-base font-bold text-white">Subject</h5>
        <el-input
          v-model="form.ReportTitle"
          placeholder="Subject"
          clearable
          :disabled="form.sendToMe"
          @blur="setFormattedMessage"
        />
      </el-form-item>

      <el-form-item prop="Message" @blur="disableEditor = true">
        <h5 class="text-base font-bold text-white">Message</h5>
        <quill-editor
          class="editor"
          ref="myTextEditor"
          :value="form.Message"
          :options="editorOption"
          :disabled="disableEditor"
          @change="onEditorChange"
          @focus="disableEditor = false"
        />
      </el-form-item>

      <div class="flex justify-end mt-2">
        <el-button type="primary" @click="submit" v-if="allowToSubmit"
          >Submit</el-button
        >
        <el-button @click="$emit('closePopup', true)">Close</el-button>
      </div>
    </el-form>
  </el-dialog>
</template>

<script>
var validateArrayOfEmail = async (rule, value, callback) => {
  const regexExp =
    /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

  // https://stackblitz.com/edit/node-stjmgq?file=index.js
  if (value && value.length > 0) {
    let pass = []
    let failed = []

    value.map((data) => {
      if (!regexExp.test(data)) {
        failed = data
      } else {
        pass = data
      }
    })

    failed.length > 0
      ? callback(new Error('Email format is invalid'))
      : callback()
  } else {
    callback(new Error('Email is required'))
  }
}
import moment from 'moment'
import debounce from 'lodash/debounce'
import { mapGetters } from 'vuex'

export default {
  props: {
    reportForm: {
      type: Object
    },
    popupOpen: {
      type: Boolean,
      default: () => false
    },
    pdfSource: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      loading: false,
      EmailList: [],
      form: {
        sendToMe: false,
        Fullname: '',
        ReportTitle: '',
        Email: '',
        ParamJsonObject: {},
        Message: ''
      },
      tmpEmail: {
        Fullname: '',
        ReportTitle: '',
        Message: ''
      },
      formRules: {
        Fullname: [
          {
            required: true,
            message: "Recipient's Name is required",
            trigger: 'change'
          }
        ],
        ReportTitle: [
          {
            required: true,
            message: 'Subject is required',
            trigger: 'change'
          }
        ],
        Email: [
          {
            required: true,
            trigger: 'change',
            validator: validateArrayOfEmail
          }
        ]
      },
      sidebarOpen: true,
      allowToSubmit: true,
      editorOption: {
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline', 'strike'],
            ['blockquote', 'code-block'],
            [{ header: 1 }, { header: 2 }],
            [{ list: 'ordered' }, { list: 'bullet' }],
            [{ header: [1, 2, 3, 4, 5, 6, false] }],
            [{ color: [] }],
            [{ align: [] }],
            ['clean']
          ],
          syntax: {
            highlight: (text) => hljs.highlightAuto(text).value
          }
        }
      },
      disableEditor: true
    }
  },
  mounted() {
    this.tmpEmail.ReportTitle = this.getReportTitle()
    this.form.ReportTitle = this.getReportTitle()
    this.EmailList = [this.user.Email]

    this.setFormattedMessage()
  },
  methods: {
    getReportTitle() {
      const formatDate = (periodType, date) => {
        if (periodType === 'Daily') return moment(date).format('DD MMM YYYY')
        else if (periodType === 'Monthly')
          return moment(date).format('MMM YYYY')
        return moment(date).format('YYYY')
      }

      const uppercaseFirstLetter = (text) => {
        return text.charAt(0).toUpperCase() + text.slice(1)
      }

      const reportType = this.reportForm.reportType
      const periodType = uppercaseFirstLetter(this.reportForm.dataForm)
      const startDate = formatDate(periodType, this.reportForm.startDate)
      const endDate = formatDate(periodType, this.reportForm.endDate)

      return `${reportType} - ${periodType} Report - ${startDate} to ${endDate}`
    },
    onEditorChange: debounce(function (value) {
      this.form.Message = value.html
    }, 466),
    setFormattedMessage() {
      var form = JSON.parse(JSON.stringify(this.form))
      var recipientName = form.Fullname ? form.Fullname : this.user.Fullname
      // console.log(form.Fullname);
      var baseTemplate =
        `<h3><span ref="FullName">${
          recipientName ? `${recipientName},` : ``
        }</span></h3>` +
        `<p>Please refer to the attachment for your <strong ref="ReportTitle">"${form.ReportTitle}"</strong>.</p>` +
        '<p>This email is generated automatically, Please do not Reply to this email.</p>' +
        '<br/><p>Thank you.</p>'

      this.disableEditor = true

      if (!this.form.Message) {
        // first load set with template
        this.form.Message = baseTemplate
      } else {
        // append fullname
        if (
          this.form.Fullname &&
          this.form.Fullname !== this.tmpEmail.Fullname
        ) {
          this.form.Message = this.form.Message.replace(
            this.tmpEmail.Fullname,
            this.form.Fullname
          )
        }

        // append reportTitle
        if (
          this.form.ReportTitle &&
          this.form.ReportTitle !== this.tmpEmail.ReportTitle
        ) {
          this.form.Message = this.form.Message.replace(
            this.tmpEmail.ReportTitle,
            this.form.ReportTitle
          )
        }
      }

      this.tmpEmail.Fullname = this.form.Fullname
        ? this.form.Fullname
        : this.user.Fullname
      this.tmpEmail.ReportTitle = this.form.ReportTitle
      this.tmpEmail.Message = this.form.Message
      // console.log(form.Message);
      // console.log(this.user)
    },

    async generatePDF() {
      try {
        var _this = this
        var pdfMake = require('pdfmake/build/pdfmake.js')

        this.loading = true
        this.$message('Generating Report, Please wait a moments.')

        if (pdfMake.vfs == undefined) {
          var pdfFonts = require('pdfmake/build/vfs_fonts.js')
          pdfMake.vfs = pdfFonts.pdfMake.vfs
        }

        await this.$store.dispatch('base64PDF', this.pdfSource)
      } catch (e) {
        this.$message.error(e)
        console.log(e)
      }
    },
    async sendPDF(data) {
      try {
        var _this = this

        // sending pdf file
        await this.$axios
          .post(this.$appInfo.api.mailList.uploadReportPDFBase64, {
            Base64: data
          })
          .then(() => {
            // submitting form data
            this.sendEmail()
          })
          .catch((error) => {
            var response = error.response
            var message = 'System Error. Please contact the administrator'

            if (response.status !== 500) {
              message = response.data.message
            }

            this.loading = false
            this.$message.error(message)
            this.disableButton = false
            throw message
          })
      } catch (e) {
        this.$message.error(e)
        console.log(e)
      }
    },
    async sendEmail() {
      try {
        // append ParamJsonObject
        const form = JSON.parse(JSON.stringify(this.form))

        form.ParamJsonObject = this.reportForm
        form.ParamJsonObject.title = this.reportForm.reportType
        form.ParamJsonObject.username = this.user.Username
        form.Email = this.form.Email.join(';')

        form.ParamJsonObject.IsSummaryOnly = JSON.parse(
          form.ParamJsonObject.IsSummaryOnly
        )

        await this.$axios.post(
          this.$appInfo.api.mailList.sendReportAndPDFToEmail,
          form
        )

        this.$notify({
          title: 'Email Sent',
          message: `Please check your Email.`,
          type: 'success',
          duration: 0
        })
        this.loading = false
        this.allowToSubmit = false
      } catch (error) {
        this.loading = false
        this.allowToSubmit = false
      }
    },
    async submit() {
      this.$refs['form'].validate(async (valid) => {
        if (valid) {
          await this.generatePDF()
        } else {
          this.loading = false
          this.$message.warning('Please fill in the email details')
        }
      })
    }
  },
  watch: {
    'form.sendToMe': {
      handler(val) {
        if (val) {
          this.form.Fullname = this.user.Fullname
          this.form.Email = [this.user.Email]
        } else {
          this.form.Fullname = ''
          this.form.Email = ''
        }
      }
    },
    'form.Email': {
      handler(val) {
        if (val) {
          for (var email of val) {
            if (!this.EmailList.find((x) => x === email)) {
              this.EmailList.push(email)
            }
          }
        }
      }
    },
    popupOpen: {
      handler(val) {
        if (val) {
          this.allowToSubmit = true
        }
      }
    },
    sendEmailFinished(val) {
      if (val) {
        this.sendPDF(this.base64Source)

        // revert status
        this.$store.commit('RESET_PROGRESS')
      }
    }
  },
  computed: {
    user() {
      return this.$store.state.auth.userData
    },
    ...mapGetters({
      sendEmailFinished: 'sendEmailFinished',
      base64Source: 'base64Source'
    })
  }
}
</script>

<style scoped>
#report-sidebar .el-select {
  width: 100% !important;
}
#report-sidebar .el-tree {
  max-height: 300px;
  overflow: auto;
}
#report-sidebar .el-form-item {
  margin-bottom: 0 !important;
}
#report-sidebar .el-form-item .el-form-item__error {
  display: none !important;
}
#report-sidebar .el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 100%;
}
</style>
